import { Translate } from "../../../../../../constant/Translate"
import { ServerValidationErrorFieldMappingType } from "../../../models/add"

const { MESSAGE_E0138, MESSAGE_E0159, MESSAGE_E0160 } = Translate

const DPTD_HIRED_LOCALLY = new Set(["DPTD028"])
const DPTD_OTHERS_STAFF_NUMBER = [
  "DPTD005",
  "DPTD006",
  "DPTD007",
  "DPTD008",
  "DPTD009",
  "DPTD010",
  "DPTD011",
  "DPTD012",
  "DPTD014",
  "DPTD016",
  "DPTD017",
  "DPTD018",
  "DPTD019",
  "DPTD021",
  "DPTD022",
  "DPTD023",
  "DPTD024",
  "DPTD025",
  "DPTD026",
  "DPTD027",
  "DPTD028",
]
const DPTD_REQUIRED_URGENT_CONTACT = [
  "DPTD002",
  "DPTD003",
  "DPTD004",
  "DPTD005",
  "DPTD008",
  "DPTD009",
  "DPTD010",
  "DPTD011",
]
const DPTD_TRAINEE = new Set(["DPTD023", "DPTD026"])
const E0017 = "E0017"
const E0105 = "E0105"
const E0106 = "E0106"
const E0107 = "E0107"
const PPTV_BUSINESS_TRAVEL = "PPTV115"
const PPTV_GO_BACK = "帰国"
const PPTV_TEMP_GO_BACK = "一時帰国"
const REGEX_ARRIVAL_DEPARTURE_VALIDATION_TRIGGER_FIELD =
  /\.(arrivalCityCode|arrivalCityName|departureCountryCode|departureCityCode|departureCityName|arrivalCountryCode)$/
const SCHEDULES_DETAIL_ROW_PREFIX = "schedulesAddDetail"
const SCHEDULES_VALIDATE_TABLE_DETAIL = "Detail"
const SCHEDULES_VALIDATE_TABLE_LODGING = "Lodging"
const SERVER_VALIDATION_ERROR_FIELD_MAPPING: Record<
  string,
  ServerValidationErrorFieldMappingType
> = {
  E0138: {
    field: "departureDate",
    message: MESSAGE_E0138,
  },
  E0159: {
    field: "departureCountryCode",
    message: MESSAGE_E0159,
  },
  E0160: {
    field: "arrivalCountryCode",
    message: MESSAGE_E0160,
  },
}
const TPTT_OTHER = "TPTT099"

export const Variables = {
  DPTD_HIRED_LOCALLY,
  DPTD_OTHERS_STAFF_NUMBER,
  DPTD_REQUIRED_URGENT_CONTACT,
  DPTD_TRAINEE,
  E0017,
  E0105,
  E0106,
  E0107,
  PPTV_BUSINESS_TRAVEL,
  PPTV_GO_BACK,
  PPTV_TEMP_GO_BACK,
  REGEX_ARRIVAL_DEPARTURE_VALIDATION_TRIGGER_FIELD,
  SCHEDULES_DETAIL_ROW_PREFIX,
  SCHEDULES_VALIDATE_TABLE_DETAIL,
  SCHEDULES_VALIDATE_TABLE_LODGING,
  SERVER_VALIDATION_ERROR_FIELD_MAPPING,
  TPTT_OTHER,
}
